var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEllipsisVerticalSolid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 21,
    viewBox: "0 0 6 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 15C4.44844 15 5.625 16.1766 5.625 17.625C5.625 19.0734 4.44844 20.25 3 20.25C1.55156 20.25 0.375 19.0734 0.375 17.625C0.375 16.1766 1.55156 15 3 15ZM3 7.5C4.44844 7.5 5.625 8.67656 5.625 10.125C5.625 11.5734 4.44844 12.75 3 12.75C1.55156 12.75 0.375 11.5734 0.375 10.125C0.375 8.67656 1.55156 7.5 3 7.5ZM5.625 2.625C5.625 4.07344 4.44844 5.25 3 5.25C1.55156 5.25 0.375 4.07344 0.375 2.625C0.375 1.17656 1.55156 0 3 0C4.44844 0 5.625 1.17656 5.625 2.625Z",
    fill: "#1A2021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsisVerticalSolid);
export default __webpack_public_path__ + "static/media/ellipsis-vertical-solid.95a9a3979975c4ab4ac12fa6251f51ce.svg";
export { ForwardRef as ReactComponent };